{
  "name": "xp-gpt-client",
  "version": "1.10.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:local": "ng serve --configuration=local",
    "build": "ng build --configuration=development",
    "build:local": "ng build --configuration=local",
    "build:staging": "ng build --configuration=staging",
    "build:qa1": "ng build --configuration=qa1",
    "build:prod": "ng build --configuration=production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:watch": "ng test --watch",
    "test:coverage": "ng test --coverage",
    "lint": "eslint && stylelint src/**/*.scss && prettier --check src/",
    "lint:fix": "eslint --fix && stylelint --fix src/**/*.scss && prettier --write src/",
    "codegen": "graphql-codegen --config codegen.ts -r dotenv/config",
    "test:e2e": "playwright test",
    "test:e2e:ui": "playwright test --ui --project=stubbed-ui",
    "test:e2e:headed": "playwright test --headed --project=stubbed-ui",
    "test:rules": "DOTENV_CONFIG_PATH=/dev/null npx --yes firebase-tools@14 emulators:exec --only storage --project demo-passkey-storage --config firebase.rules-test.json \"vitest run --config vitest.storage-rules.config.ts\""
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.3",
    "@angular/cdk": "^22.2.4",
    "@angular/common": "^22.2.3",
    "@angular/compiler": "^22.2.3",
    "@angular/core": "^22.2.3",
    "@angular/fire": "21.0.0-rc.0",
    "@angular/forms": "^22.2.3",
    "@angular/material": "^22.2.4",
    "@angular/material-moment-adapter": "^22.2.4",
    "@angular/platform-browser": "^22.2.3",
    "@angular/platform-browser-dynamic": "^22.2.3",
    "@angular/router": "^22.2.3",
    "@apollo/client": "^4.2.2",
    "@google-cloud/text-to-speech": "^6.3.1",
    "@ngneat/until-destroy": "^10.0.0",
    "@ngrx/component-store": "^22.0.1",
    "@sentry/angular": "^10.57.0",
    "@simplewebauthn/browser": "14.0.0",
    "@zxcvbn-ts/core": "^3.0.4",
    "apollo-angular": "~14.1.0",
    "dotenv": "^16.5.0",
    "encoding-japanese": "^2.2.0",
    "firebase": "^12.14.0",
    "graphql": "^16",
    "highcharts": "^12.2.0",
    "highcharts-angular": "^4.0.1",
    "ip-address": "^10.2.0",
    "lodash": "^4.18.1",
    "lodash.isequal": "^4.5.0",
    "marked": "^15.0.12",
    "moment": "^2.30.1",
    "ngx-infinite-scroll": "^22.0.0",
    "ngx-spinner": "^21.1.0",
    "papaparse": "^5.5.3",
    "qrcode": "^1.5.4",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "uuid": "^11.1.0",
    "zone.js": "~0.16.3"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.6.0",
    "@angular-eslint/eslint-plugin": "^22.6.0",
    "@angular-eslint/eslint-plugin-template": "^22.6.0",
    "@angular-eslint/schematics": "^22.6.0",
    "@angular-eslint/template-parser": "^22.6.0",
    "@angular/build": "^22.2.3",
    "@angular/cli": "^22.2.3",
    "@angular/compiler-cli": "^22.2.3",
    "@eslint/js": "^9.27.0",
    "@firebase/rules-unit-testing": "^5.0.2",
    "@graphql-codegen/cli": "^6.2.1",
    "@graphql-codegen/typescript": "^5.0.9",
    "@graphql-codegen/typescript-apollo-angular": "^5.0.0",
    "@graphql-codegen/typescript-operations": "^5.0.9",
    "@playwright/test": "1.64.1",
    "@sentry/cli": "^2.58.5",
    "@types/encoding-japanese": "^2.2.1",
    "@types/lodash": "^4.17.17",
    "@types/moment": "^2.13.0",
    "@types/papaparse": "^5.3.16",
    "@types/qrcode": "^1.5.6",
    "@types/uuid": "^10.0.0",
    "@typescript-eslint/eslint-plugin": "8.61.0",
    "@typescript-eslint/parser": "8.61.0",
    "@typescript/native-preview": "^7.0.0-dev.20260416.1",
    "@vitest/browser": "^4.1.11",
    "@vitest/browser-playwright": "^4.1.11",
    "@vitest/coverage-v8": "^4.1.11",
    "@vitest/eslint-plugin": "1.6.27",
    "angular-eslint": "^22.6.0",
    "eslint": "^9.27.0",
    "eslint-config-prettier": "^10.1.5",
    "eslint-plugin-unused-imports": "^4.1.4",
    "jsdom": "^25.0.0",
    "playwright": "1.64.1",
    "prettier": "^3.5.3",
    "socket.io-client": "^4.8.1",
    "stylelint": "^16.19.1",
    "stylelint-config-recess-order": "^6.0.0",
    "stylelint-config-recommended-scss": "^15.0.1",
    "stylelint-config-standard": "^38.0.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.61.0",
    "typescript-language-server": "5.1.3",
    "vite": "^6.4.4",
    "vitest": "^4.1.11"
  },
  "overrides": {
    "rxfire": {
      "firebase": "$firebase"
    },
    "@angular/build": {
      "vite": "8.3.4"
    },
    "@angular/fire": {
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core",
      "@angular/platform-browser": "$@angular/platform-browser",
      "@angular/platform-browser-dynamic": "$@angular/platform-browser-dynamic"
    }
  }
}
